<template>
  <v-container>
    <div v-if="betaDenied" class="custom-container custom-margin text-center">
      <v-icon large color="error">mdi-lock</v-icon>
      <h2 class="mt-4">Kein Zugriff</h2>
      <p class="mt-2">
        Diese Instanz nimmt nicht am Beta-Programm teil.<br>
        Ein Login über die Beta-Seite ist nicht möglich.
      </p>
    </div>
    <div
      v-else-if="visibleOptions === true"
      class="custom-container"
      :class="$vuetify.breakpoint.smAndDown ? 'custom-margin-mobile' : 'custom-margin'"
    >
      <div>
        <h2 class="text-center">Hallo {{$store.state.username}}</h2>
        <p class="new-line text-center">
          Bitte wähle eine Botinstanz aus, die du verwalten möchtest!
        </p>
      </div>
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="12" sm="8" md="6">
        <v-select class="custom-margin2"
                  v-model="selectedOption"
                  :items="instanceList"
                  item-text="name"
                  item-value="name"
                  outlined
                  label="Wähle deine Botinstanz">
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
                <v-chip x-small color="deep-purple" dark class="ml-2" v-if="item.beta">BETA</v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:selection="{ item }">
            <span>{{ item.name }}</span>
            <v-chip x-small color="deep-purple" dark class="ml-2" v-if="item.beta">BETA</v-chip>
          </template>
        </v-select>
        <v-btn
          class="custom-margin2"
          :block="$vuetify.breakpoint.smAndDown"
          depressed
          @click="handleOption(selectedOption)"
        >
          Auswahl bestätigen
        </v-btn>
      </v-col>
    </v-row>
    </div>
    <v-row
      class="center-container"
      align="center"
      justify="center"
      v-else
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
    <div class="error" v-if="result !== null && !result.success">
      <h2>Es ist ein unerwarter Fehler aufgetreten</h2>
      <pre>{{result.error.message}}</pre>
    </div>
  </v-container>

</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'TwitchAuthView',

  data: () => ({
    result: null,
    selectedOption: null,
    options: [],
    userid: 0,
    test: false,
    numbersOnly: '',
    visibleOptions: false,
    isBeta: 0,
    betaDenied: false,
  }),
  components: {},
  mounted() {
    this.isBeta = window.location.hostname.includes('beta.thofubot.de') ? 1 : 0;
    const pullIsBeta = this.isPublicLogin ? 0 : this.isBeta;
    BackendService.pullOptions(this.$router.currentRoute.query.code, this.$router.currentRoute.query.state, pullIsBeta).then((data) => {
      console.log(data.data);
      this.options = data.data.options;
      this.userid = data.data.userid;
      this.$store.commit('set_username', data.data.username);
      this.$store.commit('set_avatar', data.data.avatar);
      this.$store.commit('set_user_id', data.data.userid);
      const numberOfProperties = Object.keys(data.data.options).length;
      if (this.isBeta && numberOfProperties === 0 && !this.isPublicLogin) {
        this.betaDenied = true;
        return;
      }
      if (this.$router.currentRoute.query.state !== undefined) {
        console.log('HIER!!!');
        console.log(this.$router.currentRoute.query.state);
        console.log('login public möglich!');
        console.log(this.$store.state.db);
      }
      if (this.$router.currentRoute.query.state !== undefined && this.$store.state.db !== undefined) {
        const regex = /\d+/g;
        const numbers = this.$store.state.db.match(regex);
        if (numbers) {
          this.numbersOnly = numbers.join('');
          this.start(this.numbersOnly, this.numbersOnly);
        }
      } else if (numberOfProperties === 1) {
        const onlyName = Object.keys(data.data.options)[0];
        this.start(data.data.options[onlyName].botHostId, data.data.options[onlyName].tiktokHostId, onlyName);
      } else {
        this.visibleOptions = true;
      }
    });
  },
  computed: {
    instanceList() {
      return Object.keys(this.options).map((name) => ({
        name,
        beta: this.options[name].beta === true,
      }));
    },
    isPublicLogin() {
      const stateParam = this.$router.currentRoute.query?.state?.split('|');
      const publicPrefixes = ['giveaway', 'rewards', 'point_credit_log', 'equipment', 'rune_shop', 'equipment_shop'];
      return !!(stateParam && stateParam.length > 1 && publicPrefixes.includes(stateParam[0]));
    },
  },
  methods: {
    handleOption(selectedName) {
      if (selectedName !== null) {
        const selectedId = this.options[selectedName];
        console.log(`Ausgewählter Name: ${selectedName}`);
        console.log(`Ausgewählte Host ID: ${selectedId.botHostId}`);
        console.log(`Ausgewählte TikTok Host ID: ${selectedId.tiktokHostId}`);
        this.start(selectedId.botHostId, selectedId.tiktokHostId, selectedName);
      }
    },
    start(hostId, tiktokHostId, instanz) {
      BackendService.checkStatus2(hostId, tiktokHostId, this.userid, instanz, this.isBeta).then((data2) => {
        if (data2.data.betaDenied && !this.isPublicLogin) {
          this.visibleOptions = false;
          this.betaDenied = true;
          return;
        }
        // console.log('CHECK STATUS2');
        // console.log(data2.data);
        this.$store.commit('set_loggedin', data2.data.loggedIn);
        this.$store.commit('set_permname', data2.data.permname);
        this.$store.commit('set_user_perm', data2.data.user_perm);
        this.$store.commit('set_db', data2.data.db);
        this.$store.commit('set_loyaltypoints', data2.data.loyaltypoints);
        this.$store.commit('set_loyaltypoints_name', data2.data.loyaltypoints_name);
        this.$store.commit('set_monthlypoints_name', data2.data.monthlypoints_name);
        this.$store.commit('set_instanz', data2.data.instanz);
        this.$store.commit('set_hostId', data2.data.hostId);
        this.$store.commit('set_tiktok_user_perm', data2.data.tiktok_user_perm);
        this.$store.commit('set_tiktok_permname', data2.data.tiktok_permname);
        this.$store.commit('set_tiktok_db', data2.data.tiktok_db);
        this.$store.commit('set_tiktok_loyaltypoints', data2.data.tiktok_loyaltypoints);
        this.$store.commit('set_tiktok_broadcasterId', data2.data.tiktok_broadcasterId);
        this.$store.commit('set_xp', data2.data.xp);
        this.$store.commit('set_xp_name', data2.data.xp_name);
        this.$store.commit('set_xp_global', data2.data.xp_global);
        this.$store.commit('set_xp_name_global', data2.data.xp_name_global);
        // console.log(data2);
        // console.log(this.$store.state.logged_in);
        // console.log(this.$store.state.db);
        // console.log(this.$router.currentRoute.query.state);
        // console.log('Locale Storage');
        // console.log(JSON.parse(localStorage.getItem('login_from')));
        const state = this.$router.currentRoute.query?.state?.split('|');
        if (state && state.length > 1) {
          if (state[0] === 'giveaway') {
            this.$router.push(`/giveaway/${state[1]}`);
          } else if (state[0] === 'rewards') {
            this.$router.push(`/loyality_rewards/${state[1]}`);
          } else if (state[0] === 'point_credit_log') {
            this.$router.push(`/point_credit_log/${state[1]}`);
          } else if (state[0] === 'equipment') {
            this.$router.push(`/equipment_selection/${state[1]}`);
          } else if (state[0] === 'rune_shop') {
            this.$router.push(`/rune_shop/${state[1]}`);
          } else if (state[0] === 'equipment_shop') {
            this.$router.push('/equipment_shop');
          }
        } else {
          this.$router.push('/');
        }
      });
    },
  },
};
</script>
<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.custom-container {
  border: 1px solid #000;
  border-radius: 10px;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}
.custom-margin {
  margin-top: 70px;
}
.custom-margin-mobile {
  margin-top: 24px;
}
.custom-margin2 {
  margin-top: 30px;
}

@media (max-width: 599px) {
  .custom-container {
    padding: 16px;
  }
}
.new-line {
  display: block;
  margin-top: 10px; /* Dieser Abstand kann nach Bedarf angepasst werden */
}
</style>
